import { gql } from '@apollo/client';

export const FIND_HOTEL_QUERY = gql`
  # Write your query or mutation here
  fragment CommonAppActionButtonFields on AppActionButton {
    id
    iconName
    openMode
    url
    displayName
    locale
  }

  fragment CommonGenericAutoMessageFields on GenericAppAutoMessage {
    id
    btnText
    icon
    appSortOrder
    defaultMessageTemplate
    missingDataMessageTemplate
    availableFrom
    availableTo
    locale
  }

  fragment CommonBookitoSettingsFields on BookitoSettings {
    bannerImg {
      id
      url
      formats
    }
    appButtonTitle
    locale
    daysBookableInAdvance
    daysViewableInAdvance
  }

  query FindHotel($id: ID!) {
    hotel(id: $id) {
      id
      name
      code
      locationLat
      externalOrderSystemUrl
      locationLon
      receptionOpenFrom
      receptionOpenTo
      isOnTrialPlan
      accomodationType
      paymentValidUntil
      paymentUpdateUrl
      paymentCancelUrl
      paymentStatus
      subdomain
      eventsModuleConfiguration
      chatlynConfiguration
      reguestApiBaseUrl
      reguestConfiguration
      enabledIncomingNotificationChannels
      enabledOutgoingNotificationChannels
      availableLanguages
      surroundingsExternalBannerImage
      stayInformationExternalBannerImage
      homeExternalBannerImage
      bookitoSettings {
        ...CommonBookitoSettingsFields
        localizations {
          ...CommonBookitoSettingsFields
        }
      }
      dailybirdSettings {
        id
        fontFamily
      }
      pricingPlan {
        id
        name
        maxSurroundingsCategoryCards
        maxSurroundingsCards
        maxStayInformationCards
        maxTvAppConfigurations
        themingEnabled
        blogEnabled
        chatEnabled
        eventsModuleEnabled
        tvAppEnabled
        maxEmployees
        displayName
        paddleId
        carlitoAiEnabled
        isAnalyticsEnabled
      }
      welcomeMessage {
        id
        title
        subtitle
        bodyText
      }
      logo {
        id
        url
        formats
      }
      homeScreenBanner {
        id
        url
        formats
      }
      chatUserId
      chatAuthToken
      orderandoCustomercode
      customOrderModuleImage {
        id
        url
        formats
      }
      appActionButtons {
        ...CommonAppActionButtonFields
        localizations {
          ...CommonAppActionButtonFields
        }
      }
      virtualProfiles {
        id
        fullName
        profilePicture {
          id
          url
          formats
        }
      }

      genericAutoMessages {
        ...CommonGenericAutoMessageFields
        localizations {
          ...CommonGenericAutoMessageFields
        }
      }
    }
  }
`;
